import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

/**
 * Formats a given date (string or Date object) into "dd MMM yyyy" format.
 *
 * @example output
 * "19 Mar 2025"
 */
export const getFormattedDateInDDMMMYYYY = (
  dateInput: string | Date,
): string => {
  const date = typeof dateInput === 'string' ? parseISO(dateInput) : dateInput;

  return format(date, 'dd MMM yyyy');
};
